<template>
  <router-view />
</template>

<script>
export default {
  name: 'terms-of-acceptance-pages-container',
};
</script>
